import React from 'react';
import Ajax from './Ajax.js';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './index.css';
import Navbar from './NavBar';
import { optionsConfig } from './constants';
import FavoritesManager from './FavoritesManager';
import CustomDropdown from './CustomDropdown';

// Organized Quick Search Categories with Emojis
var quickSearchCategories = {
  'art-styles': {
    emoji: '🎨',
    label: 'Art Styles',
    options: [
      {term:'Fantasy,Dragons,Fairy,Faery,Fairies,Faeries', displayTerm:'Fantasy', category:'artist'},
      {term:'Sci-Fi,Science Fiction,Futuristic,Futurism,Star Wars', displayTerm:'Science Fiction', category:'artist'},
      {term:'Horror,Gothic', displayTerm:'Horror & Gothic', category:'artist'},
      {term:'Abstract', displayTerm:'Abstract Art', category:'artist'},
      {term:'Surrealism,Surrealist,Surreal', displayTerm:'Surrealism', category:'artist'},
    ]
  },
  'artists': {
    emoji: '👥',
    label: 'Artists',
    options: [
      {term:'Painter,Painting', displayTerm:'Painters', category:'artist'},
      {term:"Matte", displayTerm:'Matte Painters', category:'artist'},
      {term:'Photographer,Photography,photographers,photos,photographs', displayTerm:'Photographers', category:'artist'},
      {term:"Bijin-ga,Ukiyo-e", displayTerm:'Traditional Japanese', category:'artist'},
      {term:'Hong Kong,China,Chinese', displayTerm:'Chinese & Hong Kong', category:'artist'},
    ]
  },
  'themes': {
    emoji: '🎭',
    label: 'Themes',
    options: [
      {term:'Anime,Manga', displayTerm:'Anime & Manga', category:'artist'},
      {term:'Comics,Comic,Marvel', displayTerm:'Comics & Graphic Novels', category:'artist'},
      {term:'Animation Studio,game development,game developer', displayTerm:'Animation & Game Dev', category:'artist'},
      {term:'Light,Shadow', displayTerm:'Light & Shadow', category:'modifier'},
      {term:'Africa,African', displayTerm:'African Art', category:'artist'},
    ]
  }
};

class Guide extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchSearch:"",
        searchSearchField:"",
        searchCategory:"artist",        // Initialize with default
        searchSort:"popularity",        // Initialize with default
        searchSdVersionId:"2",
        favoritesSearch:"",
        favoritesSort:"popularity",     // Initialize with default
        favoritesSearchField:"",
        favoritesCategory:"artist",     // Initialize with default
        favoritesSdVersionId:"2",
        showingFavorites: false,
        activeTab: 0,
        isScrolled: false
      };

      this.searchPrompt = this.searchPrompt.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
      // Add scroll listener for header behavior
      window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
      // Clean up scroll listener
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldBeScrolled = scrollTop > 100;
      
      if (shouldBeScrolled !== this.state.isScrolled) {
        this.setState({ isScrolled: shouldBeScrolled });
      }
    };

    searchSearch = e => {
      this.setState({searchSearchField:e.target.value});
      return e.target.value.length >= 3 || e.target.value.length === 0 ? this.setState({searchSearch:e.target.value}) : null
    };

    favoritesSearch = e => {
      this.setState({favoritesSearchField:e.target.value});
      return e.target.value.length >= 3 || e.target.value.length === 0 ? this.setState({favoritesSearch:e.target.value}) : null
    };

    searchPrompt = function(search, category, sort, sdVersionId) {
      const selectedOptions = optionsConfig[this.state[sdVersionId]] || [];

      // Use fallback values instead of setState during render
      const currentCategory = selectedOptions.includes(this.state[category]) 
        ? this.state[category] 
        : (selectedOptions.includes('artist') ? 'artist' : selectedOptions[0] || '');
      
      const currentSort = this.state[sort] || 'popularity';
      const currentSdVersionId = this.state[sdVersionId] || '2';

      return (
        <div className="search-form-container">
          <input 
            type="text" 
            autoComplete="off" 
            value={this.state[search+'Field']} 
            onChange={this[search]} 
            className="form text" 
            placeholder="Search artists, styles, or techniques..." 
            id={search} 
          />

          <select 
            onChange={(e) => this.setState({[sdVersionId]:e.target.value})} 
            className="form select" 
            value={currentSdVersionId}
          >
            <option value="2">SDXL</option>
            <option value="1">SD1.5</option>
          </select>

          <select 
            onChange={(e) => this.setState({[category]:e.target.value})} 
            className="form select" 
            value={currentCategory}
          >
            {selectedOptions.includes('artist') && <option value="artist">Artists</option>}
            {selectedOptions.includes('character') && <option value="character">Characters</option>}
            {selectedOptions.includes('person') && <option value="person">People</option>}
            {selectedOptions.includes('modifier') && <option value="modifier">Modifiers</option>}
            {selectedOptions.includes('style') && <option value="style">Styles</option>}
            {selectedOptions.includes('all') && <option value="all">All</option>}
          </select>

          <select 
            onChange={(e) => this.setState({[sort]:e.target.value})} 
            className="form select" 
            value={currentSort}
          >
            {(currentCategory === 'artist' || !currentCategory) && <option value="popularity">Most Popular</option>}
            <option value="timestamp">New</option>
            <option value="+">A-Z</option>
            <option value="-">Z-A</option>
          </select>
        </div>
      );
    }

    handleQuickSearch = (searchTerm, category) => {
      if (this.state.activeTab === 0) {
        // Search tab
        this.setState({
          searchSearchField: searchTerm, 
          searchSearch: searchTerm, 
          searchCategory: category || this.state.searchCategory
        });
      } else if (this.state.activeTab === 1) {
        // Favorites tab
        this.setState({
          favoritesSearchField: searchTerm, 
          favoritesSearch: searchTerm, 
          favoritesCategory: category || this.state.favoritesCategory
        });
      }
    };

    renderQuickSearchCategories = () => {
      return (
        <div className="quick-search-categories">
          {Object.entries(quickSearchCategories).map(([key, categoryData]) => (
            <CustomDropdown
              key={key}
              options={categoryData.options}
              placeholder={categoryData.label}
              emoji={categoryData.emoji}
              onSelect={this.handleQuickSearch}
              className="category-dropdown"
            />
          ))}
        </div>
      );
    };

    allFavorites = function() {
      var favorites = [],
        keys = Object.keys(localStorage),
        i = keys.length;

      while ( i-- ) {
        if (localStorage.getItem(keys[i]) === keys[i]) {
          favorites.push( keys[i] );
        }
      }
      return favorites;
    }

    render() {
        return (
          <div className="app-container">
            {/* FLOATING PARTICLES BACKGROUND */}
            <div className="floating-particles">
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
              <div className="particle"></div>
            </div>

            {/* FLOATING NAVIGATION HEADER */}
            <div className="floating-navigation">
              {/* BRAND HEADER WITH SCROLL BEHAVIOR */}
              <div className={`brand-header ${this.state.isScrolled ? 'scrolled' : ''}`}>
                <h1 className="brand-title">PixelMuse.ai</h1>
                {!this.state.isScrolled && (
                  <p className="brand-tagline">Stable Diffusion Art Discovery</p>
                )}
              </div>

              <Tabs 
                selectedIndex={this.state.activeTab} 
                onSelect={tabIndex => this.setState({ 
                  activeTab: tabIndex, 
                  showingFavorites: tabIndex === 1 
                })}
              >
                {/* TAB NAVIGATION */}
                <div className="floating-tab-navigation">
                  <TabList className="floating-tab-list">
                    <Tab>Search</Tab>
                    <Tab>Favorites</Tab>
                    <Tab>About</Tab>
                  </TabList>
                </div>
                
                {/* SEARCH CONTROLS FOR SEARCH TAB */}
                {this.state.activeTab === 0 && (
                  <div className="floating-search-controls">
                    {this.searchPrompt('searchSearch', 'searchCategory', 'searchSort', 'searchSdVersionId')}
                    {this.renderQuickSearchCategories()}
                  </div>
                )}
                
                {/* SEARCH CONTROLS FOR FAVORITES TAB */}
                {this.state.activeTab === 1 && (
                  <div className="floating-search-controls">
                    {this.searchPrompt('favoritesSearch', 'favoritesCategory', 'favoritesSort', 'favoritesSdVersionId')}
                    <FavoritesManager onUpdate={() => this.setState({ lastFavoriteUpdate: Date.now() })} />
                    {/* No quick search categories on favorites tab */}
                  </div>
                )}
              </Tabs>
            </div>

            {/* MAIN CONTENT AREA - Natural document flow */}
            <div className="main-content-wrapper">
              {/* SEARCH TAB CONTENT */}
              {this.state.activeTab === 0 && !this.state.showingFavorites && (
                <div className="content-section">
                  <Ajax 
                    category={this.state.searchCategory} 
                    search={this.state.searchSearch} 
                    sort={this.state.searchSort} 
                    sdVersionId={this.state.searchSdVersionId} 
                    key={this.state.searchSearch+this.state.searchCategory+this.state.searchSort+this.state.searchSdVersionId} 
                    showFavorites={false}
                  />
                </div>
              )}
              
              {/* FAVORITES TAB CONTENT */}
              {this.state.activeTab === 1 && this.state.showingFavorites && (
                <div className="content-section">
                  <Ajax 
                    category={this.state.favoritesCategory} 
                    search={this.state.favoritesSearch} 
                    sort={this.state.favoritesSort} 
                    sdVersionId={this.state.favoritesSdVersionId} 
                    key={this.state.favoritesSearch+this.state.favoritesCategory+this.state.favoritesSort+this.state.favoritesSdVersionId+this.state.lastFavoriteUpdate} 
                    showFavorites={true}
                  />
                </div>
              )}
              
              {/* ABOUT TAB CONTENT */}
              {this.state.activeTab === 2 && (
                <div className="content-section">
                  <div className="about-content">
                    <h2>About PixelMuse.ai</h2>
                    <div style={{maxWidth:"1200px", textIndent: "30px", margin:'10px'}}>
                      <p>
                    PixelMuse.ai helps you discover and understand what various terms do in Stable Diffusion. Explore thousands of artists, styles, and techniques to enhance your AI art generation.<br />
                    <br/>
                    </p>
                  <strong>Thank you to the following:</strong><br/>
                  <ul>
                  <li><a href="https://github.com/invoke-ai/InvokeAI" target="_blank" rel="noreferrer">InvokeAI command-line interface</a> used for SD1.5.</li>
                  <li><a href="https://github.com/comfyanonymous/ComfyUI" target="_blank" rel="noreferrer">ComfyUI api</a> used for SDXL.</li>
                  <li><a href="https://www.mediawiki.org/wiki/API:Main_page" target="_blank" rel="noreferrer">Wikipedia API</a> used for search terms.</li>
                  </ul>

                  <strong>Other:</strong><br/>
                  <ul>
                  <li><a href="https://openart.ai/workflows/profile/blake?sort=latest" rel="noreferrer">OpenArt Workflows.</a></li>
                  <li><a href="https://openart.ai/workflows/blake/wWuWyqUbTHRJ1HOxsFyg" target="_blank" rel="noreferrer">aipromptguide.com SDXL basic API workflow</a></li>
                  </ul>

                  <h2>Updates</h2>
                  <h4>8-3-2025</h4>
                  <blockquote>
                  <strong>Major UI Overhaul and Update</strong>
                    <ul>
                    <li>Resolved infinite scrolling bug at some resolutions</li>
                    <li>Complete redesign with copper rose and sage green color scheme</li>
                    <li>Implemented floating navigation with smooth scrolling</li>
                    <li>Added organized quick search categories</li>
                    <li>Modern infinite scroll for better performance</li>
                    <li>Subtle effects</li>
                    </ul>
                    </blockquote>

                  <h4>6-10-2025</h4>
                  <blockquote>
                  <strong>Bug fixes</strong>
                    <ul>
                    <li>Fix for loading text so you know when nothing was found.</li>
                    <li>Fixed requests that were not canceling.</li>
                    </ul>
                    </blockquote>

                  <h4>5-12-2025</h4>
                  <blockquote>
                  <strong>Move to PixelMuse.ai</strong>
                    <ul>
                    <li>aipromptguide.com was moved to pixelmuse.ai running on an in-house server.</li>
                    <li>Added an export on aipromptguide.com that allows transferring local storage from the old domain.</li>
                    <li>Added import/export buttons to the Favorites tab.</li>
                    </ul>
                    </blockquote>

                  <h4>1-6-2024</h4>
                  <blockquote>
                  <strong>Major update to everything.</strong>
                    <ul>
                    <li>Added SDXL and I'm in the process of adding images. I'm using <strong>Charlie Chaplin</strong>, <strong>Clara Bow</strong>, <strong>Lillian Gish</strong>, and <strong>Rudolph Valentino</strong> for the new images. This is because most of their images are old enough to be in the Public Domain, and they do a good job to determine the strength of an artist. SDXL is slow, so I'm doing one good image for each prompt. I also added "Breathtaking landscape", "Man", "Woman" as test prompts, since different artists interpret these differently.</li>
                    <li>The site is now connected with ComfyUI <a href="https://openart.ai/workflows/blake/wWuWyqUbTHRJ1HOxsFyg" target="_blank" rel="noreferrer">aipromptguide.com SDXL basic API workflow</a>. Built an entirely new backend from scratch, and developed a more efficient workflow.</li>
                    <li>Added new sorting for "Most Popular" and "Z-A" and sd version selection.</li>
                    <li>Added new image viewer on click, to view full size images for that term.</li>
                    <li>Added options for "Thumb up" and "Thumb down" and a "Not Working" options on artists. This are used by the "Most Popular" sort option and to let me know what artists I should remove. I do store your Hashed browser info and IP, so that I can avoid people voting more than once while not requiring you login to contribute.</li>
                    </ul>
                    </blockquote>

                  <h4>1-14-2024</h4>
                  <blockquote>I created a custom Chat GPT, that interfaces with the prompt guide artist and style search, to help you build prompts for Stable Diffusion 1.5.<br /><a href="https://chat.openai.com/g/g-aPyIKOeK1-sd-1-5-prompt-guide" target="_blank" rel="noreferrer">https://chat.openj.com/g/g-aPyIKOeK1-sd-1-5-prompt-guide</a></blockquote>

                  <h4>5-18-2023</h4>
                  <blockquote>Nearly complete code rewrite and major db update (normalized the data). Updated to work with the newest version of InvokeAI, so I can start adding images again. Bug fixes and code cleanup.</blockquote>

                  <h4>9-26-2022</h4>
                  <blockquote>Site Launched.</blockquote>

                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )
    }
}

export default Guide;